import React from 'react';

import './styles.css';

const Spinner = () => {
	return (
		<div className="loadingSpinnerContainer">
			<div className="loadingSpinner" />
		</div>
	);
};

export default Spinner;
